import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";
import "./admin.css";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const resp = await adminLogin(email, password);
      login(resp.access_token, resp.user);
      nav("/admin");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit} data-testid="admin-login-form">
        <h1>Yagnika Admin</h1>
        <div className="sub">Restricted access</div>
        {err && <div className="login-error" data-testid="login-error">{err}</div>}
        <div className="admin-field" style={{ marginBottom: 12 }}>
          <label>Username</label>
          <input
            data-testid="admin-login-email"
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="admin-field" style={{ marginBottom: 16 }}>
          <label>Password</label>
          <input
            data-testid="admin-login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button data-testid="admin-login-submit" type="submit" className="admin-btn" style={{ width: "100%" }} disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
